(function (window) {
  // Prevent accidental typos with enums 👍
  var enums = {
    ENTER: "Enter",
  };

  // This is here for legacy reasons. This should be renamed and cleaned
  // up so it's more obvious what omni is doing. Probably also on the protoype
  // rather than a component global.
  var omni = undefined;

  /**
   * BatchGeoOmnibox is a component that wraps the autocomplete component with
   * logic to create a one box that acts as a location selector (for exact
   * matches), location bounding box generator (if you give it a location) and
   * even lets you search for specific non-location data in the dataset. For
   * example if you had a list people and their addresses you could search by
   * their names instead of addresses.
   *
   * This component as of today is mostly the original code that was
   * originally in bg.map.js then batchgeo-map.js. It lacks complete
   * documentation and a full suite of tests because this was moved over as a
   * singular step in a suite of refactorings.
   *
   * @see {@link https://github.com/pholmstr/batchgeo/issues/1938#issuecomment-664165662}
   *
   * @param {object} options An options hash
   * @param {jQuery|string|HTMLElement} options.container A jQuery element,
   * selector or HTMLElement to be used as the container to attach to. This is
   * used for sizing the results drop down.
   * @param {jQuery|string|HTMLElement} options.omniboxInput A jQuery element,
   * selector or HTMLElement to be used as the input which a user can search
   * for things. This is, to the user, the "omnibox".
   *
   */
  var BatchGeoOmnibox = function (options) {
    this.settings = $.extend(
      true,
      {
        container: null,
        omniboxInput: null,
      },
      options,
    );

    this._buildSearchBox();
  };

  BatchGeoOmnibox.prototype.buildData = function () {
    var d = window.per.dataRS;
    if (!omni) {
      var skippableRowsByIndex = window.per.mapRS.reduce((acc, curr) => {
        if (
          curr.outlier ||
          curr.invalid ||
          curr.accuracy === "unknown" ||
          !BatchGeo.goodLatLon(curr.lt, curr.ln)
        ) {
          acc[curr.r] = true;
        }
        return acc;
      }, {});
      BatchGeo.timer("build omni data");
      // TODO(tom) omni is defined as a var in this file, but is also in window
      // idk what that'll break so need more testing prior to removing
      omni = {};
      for (let i = 0; i < d.length; i++) {
        // rows
        if (skippableRowsByIndex[i]) continue; // skip row if it has no marker association
        for (var c = 0; c < d[i].length; c++) {
          // columns
          if (
            /(accuracy)/i.test(window.per.columnNames[c]) ||
            (window.per.hideaddr_cb && window.per.address_col === c)
          )
            continue;
          var v = BatchGeo.stripHTML(d[i][c]).trim(); // grab value and strip HTML
          window.per.columnNames[c] = window.per.columnNames[c] || "";
          if (v === "" || v.length > 100) continue; //  || window.per.columnNames[c].indexOf('_') != -1
          v += " (" + window.per.columnNames[c] + ")";
          if (!omni[v]) {
            omni[v] = {};
          }
          omni[v][i] = true; // omni[value of searchbox][row of map]
        }
      }
      return true;
    }
    return false;
  };

  BatchGeoOmnibox.prototype._buildSearchBox = function () {
    if (!window.per.dataRS) return;
    BatchGeo.timer("start buildOmniBox()");
    // jQuery wrap() cannot be passed a reference. It will clone it and you
    // lose your reference. For this reason we need to wrap it then find it
    this.settings.omniboxInput.wrap(
      $("<div />", { addClass: "batchgeo-omnibox" }),
    );
    this.$omniboxWrapper =
      this.settings.omniboxInput.closest(".batchgeo-omnibox");

    new BatchGeoOmniboxClearSearchButton({ omniboxInstance: this });
    this.buildData();
    this._initializeBatchGeoAutocomplete();
    this._attachListeners();
    BatchGeo.timer("end buildOmniBox()");
  };

  BatchGeoOmnibox.prototype._onInputSubmitHandler = function (event) {
    if (event.key === enums.ENTER) {
      this.runSearch(this.settings.omniboxInput.val());
      event.preventDefault();
    }
  };

  BatchGeoOmnibox.prototype._attachListeners = function () {
    var self = this;

    // Listen for keydowns and if it's the enter key the user is probably
    // trying to "submit" their search so call runSearch with the input's
    // current value.
    this.settings.omniboxInput.on("keydown", function (event) {
      self._onInputSubmitHandler(event);
    });

    // Since above we are now capturing enter key on omnibox inputs we need
    // to prevent any type of "form submission" that might be attached. By
    // default the browser will try to submit to the same page if it's
    // wrapped in a form. Since omnibox controls this now cancel out the
    // existing form submission.
    this.settings.omniboxInput.closest("form").on("submit", function () {
      return false;
    });

    BatchGeoStore.addListener(
      "MarkerLegend",
      "isFiltered",
      (newState, _oldState) => {
        if (!newState.isFiltered) this._clearSearchInput();
      },
    );
  };

  BatchGeoOmnibox.prototype._clearSearchInput = function () {
    this.settings.omniboxInput.val("").blur().trigger("change");
  };

  BatchGeoOmnibox.prototype._initializeBatchGeoAutocomplete = function () {
    var self = this;
    var autocompleteKeys = Object.keys(omni);
    var $omniboxInput = $(this.settings.omniboxInput);

    new BatchGeoAutocomplete({
      container: $omniboxInput,
      source: function (request, response) {
        var results = $.ui.autocomplete.filter(autocompleteKeys, request.term);
        response(results.slice(0, 30));
      },
      minLength: autocompleteKeys.length > 2000 ? 2 : 1,
      open: function () {
        // `this` is the input box, however, jQuery UI Autocomplete
        // attaches itself onto the elements data object and provides a
        // autocomplete namespace. From there we can access the menu and
        // then get the dropdown element.
        var $menuList = $(this).data().autocomplete.menu.element;

        // Takes the autocomplete HTML from jQ UI and formats it a bit
        // nicer. We'll get something like "Foo (category)" but We want
        // it like "Foo<br><span>Category</span>"
        $menuList.find("a").html(function (i, html) {
          return html.replace(/\((.*?)\)/, "<br/><span>$1</span>");
        });
      },
      select: function (e, ui) {
        self.runSearch(ui.item.value);
        self.settings.omniboxInput.val(ui.item.value);
        return false;
      },
    });
  };

  BatchGeoOmnibox.prototype._geocoderResultHandler = function (
    results,
    status,
  ) {
    const { MapsMarkersManager } = BatchGeoStore.getState();
    // If there are no results and an open info window,
    // close the current window and deselect rows
    if (status == "ZERO_RESULTS" && MapsMarkersManager.openStatus) {
      window.batchGeoGoogleMapsMarker.MarkerInfoWindow.close();
      BatchGeoStore.dispatch({ type: "ROW_SELECT_DESELECTALL" });
    }
    // geocoding on map from search box
    var lat, lon, rbounds, shortest, row, dbounds, i;
    var map = window.batchGeoGoogleMapsManager.getMap();
    window.openLocator = 0;
    if (!status || status !== google.maps.GeocoderStatus.OK) {
      // couldn't find address, default to full map
      rbounds = new google.maps.LatLngBounds();
      for (i = 0; i < window.per.mapRS.length; i++) {
        if (parseFloat(window.per.mapRS[i].lt)) {
          rbounds.extend(
            new google.maps.LatLng(
              window.per.mapRS[i].lt,
              window.per.mapRS[i].ln,
            ),
          );
        }
      }
      lat = rbounds.getCenter().lat();
      lon = rbounds.getCenter().lng();

      row = -1;
    } else {
      lon = results[0].geometry.location.lng();
      lat = results[0].geometry.location.lat();

      //this sets searchLocation state so listener will recall BatchGeoStoreLocator.updateLocations();
      this.BatchGeoStore.dispatch({
        type: "STORE_UPDATE_SEARCH_LOCATION",
        searchLocation: { lon, lat },
      });

      rbounds = results[0].geometry.bounds;

      shortest = 9999999;
      row = -1;
      for (i = 0; i < window.per.mapRS.length; i++) {
        const dist = BatchGeo.distance(
          parseFloat(window.per.mapRS[i].lt),
          parseFloat(window.per.mapRS[i].ln),
          lat,
          lon,
        ).toFixed(2);
        if (
          parseFloat(dist) < parseFloat(shortest) &&
          window.batchGeoGoogleMapsMarker.getMarkersObjArray()[i]
        ) {
          row = i;
          shortest = dist;
        }
      }
      // stash the marker data
      const searchMarker = results[0];
      window.batchGeoGoogleMapsMarker.MarkerDrawer.addSearchMarker(
        searchMarker,
      );
    }

    if (rbounds) {
      dbounds = rbounds;
    } else {
      dbounds = new google.maps.LatLngBounds();
      dbounds.extend(new google.maps.LatLng(lat, lon));
    }

    if (row < 0) {
      map.fitBounds(dbounds);
      window.batchGeoGoogleMapsMarker.MarkerDrawer.draw();
      return;
    }

    dbounds.extend(
      new google.maps.LatLng(
        window.per.mapRS[row].lt,
        window.per.mapRS[row].ln,
      ),
    );

    if (
      window.batchGeoGoogleMapsMarker.getMarkersObjArray() &&
      window.batchGeoGoogleMapsMarker.getMarkersObjArray()[row]
    ) {
      map.fitBounds(dbounds);
      window.batchGeoGoogleMapsMarker.MarkerDrawer.draw();
      BatchGeoStore.dispatch({
        type: "ROW_SELECT_SELECT",
        selectedRows: [row],
      });
    }
  };

  BatchGeoOmnibox.prototype.runSearch = function (search) {
    if (window.openLocator) return false;
    this.buildData();
    var isZip = BatchGeo.isNumber(search) && search.length === 5; // always geocode when zip
    const globalMarkerLegend = window.batchGeoGoogleMapsMarker.MarkerLegend;
    const hasLegend =
      globalMarkerLegend.isActive() &&
      window.per.legend_columns &&
      window.per.legend_columns.length;
    if (search === "") {
      this._geocoderResultHandler(null);
      return false;
    } else if (omni && omni[search] && !isZip) {
      // check omni match first
      var s = search.split("(");
      var group = s[0].trim();
      var column = s[1].replace(/\)/, "").trim();

      var firstRow =
        Object.size(omni[search]) > 0
          ? window.per.mapRS[Object.keys(omni[search])[0]]
          : {};
      var sameLocation = (i) => {
        var currentRow = window.per.mapRS[i];
        return firstRow.lt === currentRow.lt && firstRow.ln === currentRow.ln;
      };

      if (
        (Object.size(omni[search]) === 1 ||
          Object.keys(omni[search]).every(sameLocation)) &&
        !window.batchGeoStoreLocator
      ) {
        // only one result, or all results are the same location, zoom map here instead of adding filter
        for (var r in omni[search]) {
          if (window.batchGeoGoogleMapsMarker.getMarkersObjArray()[r]) {
            window.batchGeoGoogleMapsMarker.MarkerInfoWindow.smoothOpenMarker(
              r,
              true,
              false,
            );
            return false;
          }
        }
      } else {
        // exact match, they would have found it by selecting from drop down
        const searchBounds = new google.maps.LatLngBounds();
        Object.keys(omni[search]).forEach((markerSearchResultIndex) => {
          const markersObj =
            window?.batchGeoGoogleMapsMarker?.getMarkersObjArray();
          if (
            markersObj &&
            markersObj[markerSearchResultIndex] &&
            markersObj[markerSearchResultIndex].marker
          ) {
            // marker object is available
            // valid item at markerSearchResultIndex
            // valid marker in item
            searchBounds.extend(
              markersObj[markerSearchResultIndex].marker.getPosition(),
            );
          }
        });
        if (searchBounds.isEmpty()) {
          return false;
        }
        window.batchGeoGoogleMapsManager
          .getMap()
          .setCenter(searchBounds.getCenter());
        window.batchGeoGoogleMapsManager.getMap().fitBounds(searchBounds);
        if (hasLegend) {
          if (!globalMarkerLegend.filterExists(column, group)) {
            globalMarkerLegend.createFilter(column, group, omni[search], true);
            globalMarkerLegend.selectColumn(column);
            globalMarkerLegend.update(true);
          }
          return false;
        } else {
          //no legend available, but we still want to at least highlight the matching markers on map/in table
          BatchGeoStore.dispatch({
            type: "ROW_SELECT_SELECT",
            selectedRows: Object.keys(omni[search]).map((i) => parseInt(i)),
          });
          return false;
        }
      }
    } else if (omni && !isZip) {
      // do partial match search
      var combined = {};
      for (var key in omni) {
        // Key will return something like: `Foo (Bar)` where Foo is the
        // actual key and Bar is the column name. For example, it might
        // say `CO (State)`. However, we don't want to search column
        // name because it would always return every row. This removes
        // that. Note: if a user makes a column name with a parentheses
        // it can cause unexpected results as it will think its a column
        const keyOnly = key
          .split(/\s?\(.+\)/)[0]
          .trim()
          .toLowerCase();
        if (keyOnly.indexOf(search.toLowerCase()) > -1) {
          combined = $.extend(combined, omni[key]);
        }
      }

      if (hasLegend) {
        if (
          Object.size(combined) > 0 &&
          !globalMarkerLegend.filterExists("Search", search)
        ) {
          // only create filter if results found
          globalMarkerLegend.createFilter("Search", search, combined, true);
          globalMarkerLegend.update(true);
          return false;
        }
      }
    }

    // we didn't get any exact matches so we're going to geocode the search and pop nearest location
    window.openLocator = 1;
    var geocoder = new google.maps.Geocoder();
    BatchGeo.timer("geocoding " + search + "...");
    geocoder.geocode(
      { address: search, bounds: window.bounds },
      this._geocoderResultHandler,
    );
    return false;
  };

  window.BatchGeoOmnibox = BatchGeoOmnibox;
})(window);
